'use client';

import { useEffect, useRef, useState } from 'react';

type LazyImageProps = {
  src: string;
  alt: string;
  containerStyle?: React.CSSProperties;
  className?: string;
};

export function LazyImage({ src, alt, containerStyle, className }: LazyImageProps) {
  const [isInView, setIsInView] = useState(false);
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const el = containerRef.current;
    if (!el) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry?.isIntersecting) setIsInView(true);
      },
      {
        rootMargin: '100px 200px 100px 100px',
        threshold: 0.01,
      }
    );

    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  const placeholderHeight = containerStyle?.height ?? 280;

  return (
    <div ref={containerRef} className={`overflow-hidden ${className ?? ''}`} style={containerStyle}>
      {isInView ? (
        <img
          src={src}
          alt={alt}
          decoding="async"
          style={{
            objectFit: 'cover',
            width: '100%',
            minWidth: containerStyle?.minWidth ?? 280,
            maxWidth: containerStyle?.maxWidth ?? 380,
            height: placeholderHeight,
          }}
        />
      ) : (
        <div
          className="animate-pulse bg-gray-800 w-full"
          style={{
            height: placeholderHeight,
            minWidth: containerStyle?.minWidth ?? 280,
            maxWidth: containerStyle?.maxWidth ?? 380,
          }}
        />
      )}
    </div>
  );
}
